import { writable } from 'svelte/store';

export default (() => {
	const { subscribe, set, update } = writable({
        registrationsOpen: false,
        profilePicHide: true,
        disableUploadPicAndDobProof: true,
        comingsoonOpen : false 
    });

	return {
		subscribe,
        update: () => {
            console.error("You cannot update this store.")
        }
	};
})();